/* ===== THORNWOVEN 2 — SCROLL ANIMATIONS ===== */

(function () {
  'use strict';

  // Wait for GSAP and ScrollTrigger
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  // ── Loading / Intro Animation ──
  function playIntro() {
    const loader = document.getElementById('loader');
    const logo = document.getElementById('loaderLogo');
    const left = document.getElementById('loaderLeft');
    const right = document.getElementById('loaderRight');

    if (!loader || !logo) return Promise.resolve();

    // Skip if already seen this session
    if (sessionStorage.getItem('tw-loaded')) {
      loader.style.display = 'none';
      return Promise.resolve();
    }

    sessionStorage.setItem('tw-loaded', '1');

    return new Promise((resolve) => {
      const tl = gsap.timeline({
        onComplete: () => {
          loader.classList.add('done');
          gsap.set(loader, { display: 'none' });
          resolve();
        },
      });

      tl.to(logo, { opacity: 1, duration: 0.6, ease: 'power2.out' })
        .to(logo, { scale: 1.1, duration: 0.8, ease: 'power2.inOut' }, '+=0.4')
        .to(
          left,
          { xPercent: -100, duration: 0.8, ease: 'power3.inOut' },
          '-=0.3'
        )
        .to(
          right,
          { xPercent: 100, duration: 0.8, ease: 'power3.inOut' },
          '<'
        )
        .to(logo, { opacity: 0, duration: 0.3 }, '-=0.5');
    });
  }

  // ── Hero Animations ──
  function animateHero() {
    const title = document.querySelector('.hero-title');
    const actions = document.querySelector('.hero-actions');

    // Split title text into words
    if (title && typeof SplitType !== 'undefined') {
      const split = new SplitType(title, { types: 'lines, words' });

      // Wrap lines with generous padding to avoid clipping italic serifs
      split.lines.forEach((line) => {
        const wrapper = document.createElement('div');
        wrapper.style.overflow = 'visible';
        line.parentNode.insertBefore(wrapper, line);
        wrapper.appendChild(line);
      });

      gsap.to(split.words, {
        y: 0,
        opacity: 1,
        duration: 0.8,
        stagger: 0.04,
        ease: 'power3.out',
        delay: 0.2,
      });
    }

    // Fade in actions
    if (actions) {
      gsap.to(actions, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        delay: 1,
      });
    }


    // Hero parallax on scroll
    if (title) {
      gsap.to(title, {
        yPercent: 30,
        opacity: 0,
        scrollTrigger: {
          trigger: '.hero',
          start: 'top top',
          end: 'bottom top',
          scrub: 1,
        },
      });
    }

    const heroCross = document.querySelector('.hero-cross');
    if (heroCross) {
      gsap.to(heroCross, {
        scale: 1.5,
        opacity: 0,
        scrollTrigger: {
          trigger: '.hero',
          start: 'top top',
          end: 'bottom top',
          scrub: 1,
        },
      });
    }
  }

  // ── Generic Scroll Reveals ──
  function initScrollReveals() {
    // Fade up elements
    gsap.utils.toArray('.anim-fade-up').forEach((el) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            once: true,
          },
        }
      );
    });

    // Stagger children
    gsap.utils.toArray('.anim-stagger').forEach((container) => {
      gsap.fromTo(
        container.children,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.12,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: container,
            start: 'top 80%',
            once: true,
          },
        }
      );
    });
  }

  // ── Text Split Reveals ──
  function initTextReveals() {
    if (typeof SplitType === 'undefined') return;

    gsap.utils.toArray('[data-split="lines"]').forEach((el) => {
      if (el.classList.contains('hero-title')) return; // Hero handled separately

      const split = new SplitType(el, { types: 'lines, words' });

      split.lines.forEach((line) => {
        const wrapper = document.createElement('div');
        wrapper.style.overflow = 'hidden';
        line.parentNode.insertBefore(wrapper, line);
        wrapper.appendChild(line);
      });

      gsap.fromTo(
        split.words,
        { y: '100%', opacity: 0 },
        {
          y: '0%',
          opacity: 1,
          duration: 0.6,
          stagger: 0.03,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 82%',
            once: true,
          },
        }
      );
    });

    gsap.utils.toArray('[data-split="words"]').forEach((el) => {
      if (el.classList.contains('hero-title')) return;

      const split = new SplitType(el, { types: 'words' });

      gsap.fromTo(
        split.words,
        { opacity: 0, y: 15 },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.02,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 82%',
            once: true,
          },
        }
      );
    });
  }

  // ── Image Clip Reveals ──
  function initClipReveals() {
    gsap.utils.toArray('.anim-clip-reveal').forEach((el) => {
      gsap.to(el, {
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 1.2,
        ease: 'power3.inOut',
        scrollTrigger: {
          trigger: el,
          start: 'top 75%',
          once: true,
        },
      });
    });
  }

  // ── Pillar Border Draw ──
  function initPillarAnimations() {
    gsap.utils.toArray('.pillar').forEach((pillar, i) => {
      gsap.fromTo(
        pillar,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          delay: i * 0.15,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.pillars',
            start: 'top 75%',
            once: true,
            onEnter: () => pillar.classList.add('revealed'),
          },
        }
      );
    });
  }

  // ── Mission Cross Watermark ──
  function initMissionAnimation() {
    const cross = document.querySelector('.mission-cross');
    if (!cross) return;

    gsap.to(cross, {
      opacity: 0.03,
      scale: 1.1,
      rotation: 5,
      scrollTrigger: {
        trigger: '.mission',
        start: 'top 80%',
        end: 'bottom 20%',
        scrub: 1,
      },
    });
  }

  // ── Horizontal Scroll Lookbook ──
  function initLookbookScroll() {
    const wrapper = document.querySelector('.lookbook-wrapper');
    const track = document.getElementById('lookbookTrack');
    if (!wrapper || !track) return;

    // Only pin on desktop
    const mm = gsap.matchMedia();

    mm.add('(min-width: 901px)', () => {
      const totalScroll = track.scrollWidth - wrapper.offsetWidth;

      gsap.to(track, {
        x: -totalScroll,
        ease: 'none',
        scrollTrigger: {
          trigger: wrapper,
          start: 'top 15%',
          end: () => '+=' + totalScroll,
          pin: true,
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });
    });

    // On mobile, native horizontal scroll with snap
    mm.add('(max-width: 900px)', () => {
      track.style.overflowX = 'auto';
      track.style.scrollSnapType = 'x mandatory';
      track.querySelectorAll('.lookbook-item').forEach((item) => {
        item.style.scrollSnapAlign = 'start';
      });
    });
  }

  // ── Symbol Image Parallax ──
  function initSymbolParallax() {
    const img = document.querySelector('.symbol-cross-img');
    if (!img) return;

    gsap.to(img, {
      yPercent: -15,
      scrollTrigger: {
        trigger: '.symbol',
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
      },
    });
  }

  // ── Master Init ──
  async function init() {
    await playIntro();
    animateHero();
    initScrollReveals();
    initTextReveals();
    initClipReveals();
    initPillarAnimations();
    initMissionAnimation();
    initLookbookScroll();
    initSymbolParallax();

    // Refresh ScrollTrigger after all setup
    ScrollTrigger.refresh();
  }

  // Run when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
